const STORAGE_KEY_PREFIX = "wf-hri-";

export interface HriCallbackState {
  next: string;
  onCancelled?: string;
  onError?: string;
}

function getRandomStateString(): string {
  const randomBytes = window.crypto.getRandomValues(new Uint8Array(32));
  return btoa(String.fromCharCode(...randomBytes))
    .replace(/=/g, "")
    .replace(/\+/g, "-")
    .replace(/\//g, "_");
}

export function storeState(state: HriCallbackState) {
  const key = getRandomStateString();
  if (window.sessionStorage.getItem(`${STORAGE_KEY_PREFIX}${key}`)) {
    // Unlikely but a possibility all the same.
    throw new Error("HRI state key somehow already exists");
  }

  const stateString = JSON.stringify(state);
  window.sessionStorage.setItem(`${STORAGE_KEY_PREFIX}${key}`, stateString);

  return key;
}

export function getState(key: string): HriCallbackState {
  const stateString = window.sessionStorage.getItem(`${STORAGE_KEY_PREFIX}${key}`);
  if (!stateString) {
    throw new Error("State not found");
  }

  try {
    const state = JSON.parse(stateString);
    if (state.next === undefined) {
      throw new Error("Invalid state");
    }

    return state as HriCallbackState;
  } catch {
    throw new Error("Invalid state");
  } finally {
    window.sessionStorage.removeItem(`${STORAGE_KEY_PREFIX}${key}`);
  }
}
